import type { State } from '../../typings'
import type { ActivityDetails } from '../../../typings'
import { initialState } from '../../initState'

export const createLeadActivityProducer = (
  state: State,
  payload?: ActivityDetails,
): State => {
  const activities = payload
    ? [...state.activities, payload]
    : [...state.activities]

  return {
    ...initialState,
    filters: state.filters,
    history: state.history,
    activities,
  }
}
